module.exports = "<nav class=\"col-12 d-flex align-items-center logos py-4\">\n  <img src=\"/assets/LogoGroup.png\" alt=\"\" class=\"img-fluid\">\n</nav>"